import { Grid } from '@mui/material';
import SectionInfoDetail from './section-info-detail/section-info-detail.component';
import SectionInfoTitle from './section-info-title/section-info-title.component';
import { ReactNode } from 'react';

type DetailsSingleSectionProps = {
  title: string;
  detail: ReactNode;
  key?: string;
  popoverContent?: any;
};

const DetailsSingleSection = ({
  title,
  detail,
  popoverContent,
}: DetailsSingleSectionProps) => (
  <Grid size={{ xs: 6 }} mb={1}>
    <SectionInfoTitle title={title} popoverContent={popoverContent} />
    <SectionInfoDetail detail={detail} />
  </Grid>
);

export default DetailsSingleSection;
